// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-details {
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: rgba(247, 232, 186, 0.397);
  justify-content: space-evenly;
  height: 50px;
  align-items: center;
  min-width: 70px;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
  padding: 1vh;
}`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/UploadContentNewsie/NewsiePreview/NewsieBottomBar/NewsieBottomBar.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB,EAAE,WAAW,EACf,oBAAoB;EAC3C,iBAAiB,EAAE,oBAAoB;EACvC,YAAY;AACd","sourcesContent":[".game-details {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  background-color: rgba(247, 232, 186, 0.397);\n  justify-content: space-evenly;\n  height: 50px;\n  align-items: center;\n  min-width: 70px;\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10 and IE 11 */\n  user-select: none; /* Standard syntax */\n  padding: 1vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
